import { useMemo } from "react";
import { useAppSelector } from "store/hooks";

const useIsNewestField = (elementName: string): boolean => {
  const newestFieldName = useAppSelector(
    (state) => state.developer.edit.editor.newestFieldName
  );

  const isNewestField = useMemo(() => {
    const name = elementName;
    return name === newestFieldName;
  }, [elementName, newestFieldName]);

  return isNewestField;
};

export default useIsNewestField;
